// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1zSSx","label":"SetPasswdForm_label__G8h-G"};